import { css } from 'styled-components';

export interface BorderProps {
  border?: string;
  borderTop?: string;
  borderRight?: string;
  borderBottom?: string;
  borderLeft?: string;
}

export type StyledBorderProps = {
  [K in keyof BorderProps as `$${K}`]: BorderProps[K];
};

export const borderStyles = css<StyledBorderProps>`
  ${({ $border }) =>
    $border &&
    css`
      border: ${$border};
    `}

  ${({ $borderTop }) =>
    $borderTop &&
    css`
      border-top: ${$borderTop};
    `}

  ${({ $borderRight }) =>
    $borderRight &&
    css`
      border-right: ${$borderRight};
    `}

  ${({ $borderBottom }) =>
    $borderBottom &&
    css`
      border-bottom: ${$borderBottom};
    `}

  ${({ $borderLeft }) =>
    $borderLeft &&
    css`
      border-left: ${$borderLeft};
    `}
`;